// Reveal-on-scroll observer for .maahi-reveal elements
(function () {
  if (typeof IntersectionObserver === 'undefined') {
    document.querySelectorAll('.maahi-reveal').forEach(el => el.classList.add('is-visible'));
    return;
  }

  const reveal = (el) => el.classList.add('is-visible');

  const io = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          reveal(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
  );

  const init = () => {
    document.querySelectorAll('.maahi-reveal:not(.is-visible)').forEach((el) => io.observe(el));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Also reveal anything that was already in view on load (above the fold)
  window.requestAnimationFrame(() => {
    document.querySelectorAll('.maahi-reveal').forEach((el) => {
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.95) reveal(el);
    });
  });
})();
